import React from "react";
import { connect } from "react-redux";
import { getNotifications } from "../external/actions";
import { Pane, Text } from "evergreen-ui";
import { getCookie, getFormattedDate, timeAddition } from "../util";
import Loader from "../components/loader";
import BackBar from "../components/backBar";

import { Strong } from "evergreen-ui";
import { notification } from "antd";

class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: "",
      loader: false,
      nextPage: 1,
      currentPage: "",
      totalPage: "",
      loader: false,
    };
    this.baseState = this.state;
  }

  componentDidMount = async () => {
    await this.setState({
      ...this.baseState,
    });
    let reqParams = {
      page: 1,
    };
    await this.setState({ loader: true });
    await this.props.dispatch(getNotifications(reqParams, []));
    await this.setState({
      notifications: this.props.notificationData && this.props.notificationData.notifications,
      loader: false,
      nextPage:
        this.props.notificationData &&
        this.props.notificationData["pagination_data"] &&
        this.props.notificationData["pagination_data"]["next"],
    });
    // let reqParams = {
    //   page: 1,
    // };

    // await this.props.dispatch(getNotifications(reqParams));
    await this.onLoad();
  };

  componentWillUnmount() {}

  handleSeeMore = async () => {
    const { loader, notifications } = this.state;

    // const scrollTop =
    //   (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    // const scrollHeight =
    //   (document.documentElement && document.documentElement.scrollHeight) ||
    //   document.body.scrollHeight;
    // const clientHeight = document.documentElement.clientHeight || window.innerHeight;
    // const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    let endList =
      (this.props.notificationData &&
        this.props.notificationData["pagination_data"] &&
        this.props.notificationData["pagination_data"]["next"]) ||
      1;

    // if ( endList && endList !== -1 && !loader) {
    let reqParams = {
      page: endList,
    };
    await this.setState({ loader: true });
    await this.props.dispatch(
      getNotifications(
        reqParams,
        (this.props.notificationData && this.props.notificationData.notifications) || []
      )
    );
    await this.setState({
      notifications: this.props.notificationData && this.props.notificationData.notifications,
      loader: false,
      nextPage:
        this.props.notificationData &&
        this.props.notificationData["pagination_data"] &&
        this.props.notificationData["pagination_data"]["next"],
    });
  };

  onLoad = async () => {
    window.addEventListener("scroll", this.onScroll, false);
  };

  render() {
    const { notifications, loader, nextPage } = this.state;

    return (
      <React.Fragment>
        <BackBar  title={"Notifications"}/>
        {notifications.length !== 0 ? (
          <Pane paddingRight={16} paddingLeft={16}>
            {notifications &&
              notifications.map((notification, index) => (
                <Pane
                  key={index}
                  padding={10}
                  borderBottom={"1px solid rgba(66, 90, 112, 0.2)"}
                  display={"flex"}
                  flexDirection={"column"}
                >
                  <Text>{notification["content"]}</Text>
                  <Text size={300} marginTop={5} color={"muted"}>
                    {getFormattedDate(
                      notification["timestamp"],
                      "YYYY-MM-DD HH:mm:ss",
                      "ddd, Do MMM-YYYY"
                    )}
                  </Text>
                </Pane>
              ))}{" "}
            {loader && <Loader />}
          </Pane>
        ) : (
          <Pane
            paddingRight={16}
            height={120}
            display='flex'
            justifyContent='center'
            alignItems='center'
            paddingLeft={16}
          >
            {" "}
            <Text>No notification to show</Text>
          </Pane>
        )}
        {nextPage !== -1 ? (
          <Pane
            height={40}
            display='flex'
            flexDirection='row'
            alignItems={"center"}
            justifyContent='center'
          >
            <Strong
              onClick={this.handleSeeMore}
              textDecoration='underline'
              size={400}
              appearance={"minimal"}
            >
              See more
            </Strong>
          </Pane>
        ) : (
          notifications.length !== 0 && (
            <Pane
              height={40}
              display='flex'
              flexDirection='row'
              alignItems={"center"}
              justifyContent='center'
            >
              <Strong size={400} appearance={"minimal"} color='primary'>
                No more notifications available
              </Strong>
            </Pane>
          )
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ notificationData }) => ({
  notificationData,
});

export default connect(mapStateToProps)(Notifications);
